// Group once per server update instead of rescanning every comment on
// every Story passage render. Preserve source order for existing UI behaviour.
export function indexStoryComments(comments=[]) {
  const byBlock=new Map(),openCounts=new Map(),byId=new Map();
  for(const comment of comments){
    if(!byBlock.has(comment.block_id))byBlock.set(comment.block_id,[]);
    byBlock.get(comment.block_id).push(comment);
    if(comment.status==='open')openCounts.set(comment.block_id,(openCounts.get(comment.block_id)||0)+1);
    byId.set(comment.id,comment);
  }
  return {byBlock,openCounts,byId};
}
